import PropTypes from 'prop-types';
import React from 'react';

function BreakCandleTypeWrapper({ softOrder, Component, ...rest }) {
  const details = {
    tacticName: 'BREAK_CANDLE_TYPE',
    category: 'Setup',
    type: 'Break Candle Type',
    domain: 'Underlying',
  };
  const priceToBreak = softOrder.priceToBreak;
  const candleDuration = softOrder.candleDuration;
  const breakBy = softOrder.breakBy;

  return (
    <Component
      details={details}
      breakBy={breakBy}
      priceToBreak={priceToBreak}
      candleDuration={candleDuration}
      {...rest}
    />
  );
}

BreakCandleTypeWrapper.propTypes = {
  Component: PropTypes.any,
  softOrder: PropTypes.shape({
    breakBy: PropTypes.any,
    candleDuration: PropTypes.any,
    priceToBreak: PropTypes.any
  })
};


export default BreakCandleTypeWrapper;
